<basin-pull-down-container *ngIf="simulationTrackers && simulationTrackers.length > 0">
  <ng-container slot="main">
    <div class="basin-width-100 basin-display-flex basin-flex-column basin-gap-1 basin-pb-1">
      <div
        class="basin-width-100 basin-display-flex basin-flex-column basin-align-items-center basin-justify-content-center">
        <div
          class="basin-width-100 basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-space-between">
          <div
            class=" title-text  basin-font-secondary basin-color-true-white basin-font-size-20 basin-font-weight-700 basin-pr-1">
            {{ getName(simulationTrackers[0]) }}
          </div>
          <div [ngClass]="getStatusColorClass(simulationTrackers[0])"
            class="basin-font-uppercase basin-font-weight-500 basin-font-size-14 basin-white-space-nowrap">
            {{ statusMap[simulationTrackers[0].status!] || '' }}
          </div>
        </div>
        <div class="basin-width-100 basin-text-align-left basin-color-true-white basin-font-size-14">
          {{ simulationTrackers[0].timestamp | date: 'MM-dd-yyyy HH:mm' }}
        </div>
      </div>
      <div *ngIf="willEmailResults(simulationTrackers[0])"
        class="basin-width-100 basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-space-between basin-gap-1">
        <div class="symbol-warning basin-color-yellow-75 basin-font-size-24"></div>
        <div class="basin-color-true-white basin-font-size-14">
          Once the simulation is complete, an email will be sent to you with confirmation.
        </div>
      </div>
      <p-button *ngIf="isSuccessful(simulationTrackers[0])" label="View Results" styleClass="p-button-text"
        icon="symbol-map symbol-outlined" (onClick)="viewSimulationResultsWithoutDilogBox(simulationTrackers[0])">
      </p-button>
    </div>
  </ng-container>

  <ng-container slot="drawer">
    <div class="basin-overflow-y-auto" style="max-height: 420px;">
      <ng-container *ngFor="let tracker of simulationTrackers; let i = index">
        <div *ngIf="i !== 0"
          class="simulation-list-item basin-width-100 basin-display-flex basin-flex-column basin-gap-1 basin-py-3">
          <div
            class="basin-width-100 basin-display-flex basin-flex-column basin-align-items-center basin-justify-content-center">
            <div
              class="basin-width-100 basin-display-flex basin-flex-row basin-align-items-center basin-justify-content-space-between">
              <div class="basin-color-true-white basin-font-size-14 basin-pr-1">
                {{ getName(tracker) }}
              </div>
              <div [ngClass]="getStatusColorClass(tracker)"
                class="basin-font-uppercase basin-font-weight-500 basin-font-size-14 basin-white-space-nowrap">
                {{ statusMap[tracker.status!] || '' }}
              </div>
            </div>
            <div class="basin-width-100 basin-text-align-left basin-color-true-white basin-font-size-14">
              {{ tracker.timestamp | date: 'MM-dd-yyyy HH:mm' }}
            </div>
          </div>
          <p-button *ngIf="isSuccessful(tracker)" label="View Results" styleClass="p-button-text"
            icon="symbol-map symbol-outlined" (onClick)="viewSimulationResultsWithoutDilogBox(tracker)">
          </p-button>
        </div>
      </ng-container>
    </div>

  </ng-container>
</basin-pull-down-container>